import { convertToISOFormat } from "./utility";

export const getCurrentDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  let month = today.getMonth() + 1;
  let day = today.getDate();

  // Add leading zero if month/day is a single digit
  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }

  return `${year}-${month}-${day}`;
};
export function getCurrentIndianTime() {
  const now = new Date();

  const offsetIST = 5.5 * 60 * 60 * 1000; // 5 hours 30 minutes in milliseconds
  const indianTime = new Date(now.getTime() + offsetIST);

  const hours = String(indianTime.getUTCHours()).padStart(2, "0");
  const minutes = String(indianTime.getUTCMinutes()).padStart(2, "0");

  return `${hours}:${minutes}`;
}

export const initialValuesForExpense = (item = null) => {
  return {
    expenseCategory: item ? item.expenseCategory : "office_Expense",
    expenseName: item ? item.expenseName : "",
    expenseOtherCategory: item ? item.expenseOtherCategory : "",
    otherStatus: item ? item.otherStatus : "",

    employeeName:
      item && item.salaryDetails ? item.salaryDetails.employeeName : "",
    paidTo: item ? item.paidTo : "",
    amount: item ? item.amount : "",
    salaryPeriod:
      item && item.salaryDetails ? item.salaryDetails.salaryPeriod : "",
    salaryDateFrom: item ? item.salaryDateFrom : "",
    salaryDateTo: item ? item.salaryDateTo : "",
    modeOfPayment: item ? item.modeOfPayment : "cash",
    date: item ? convertToISOFormat(item.date) : getCurrentDate(),
    expenseTime: item ? item.expenseTime : getCurrentIndianTime(),
    creatorName: item ? item.creatorName : "",
    creatorRole: item ? item.creatorRole : "",
    document: item ? item.document : null,
    status: item ? item.status : "pending",
    employeeMobile:
      item && item.salaryDetails ? item.salaryDetails.employeeMobile : "",
    taxable_expense: item ? item.taxable_expense : "no_tax",
    igst: item ? item?.igst : "",
    cgst: item ? item?.cgst : "",
    sgst_utgst: item ? item?.sgst_utgst : "",
    cess: item ? item?.cess : "",
    totalAmount: item ? item.totalAmount : "0",
    approvedDate: item
      ? convertToISOFormat(item.approvedDate)
      : getCurrentDate(),
    // expenseOtherCategory: item ? item.expenseOtherCategory : "no-selected",
  };
};

export const initialValuesForCustomers = (item = null) => {
  return {
    name: item ? item.name : "",
    customer_mobile: item ? item.customer_mobile : "",
    gstIN: item ? item.gstIN : "",
    shippingAddress: item ? item.shippingAddress : "",
    billingAddress: item ? item.billingAddress : "",
    pincode: item ? item.pincode : "",
    ageGroup: item ? item.ageGroup : "",
    // bankDetails: {
    accountNumber:
      item && item.bankDetails ? item.bankDetails.accountNumber : "",
    ifscNumber: item && item.bankDetails ? item.bankDetails.ifscNumber : "",
    accountType:
      item && item.bankDetails ? item.bankDetails.accountType : "savings",
    // },
    items: [],
    itemUnit: item ? item.itemUnit : "",
    perferedCommunication: item ? item.perferedCommunication : "email",
    transactionStatus: item ? item.transactionStatus : "",
    totalAmount: item ? item.totalAmount : "",
    pendingAmount: item ? item.pendingAmount : "",
    advanceAmount: item ? item.advanceAmount : "",
    paidAmount: item ? item.paidAmount : "",
    email: item ? item.email : "",
    pan: item ? item.pan : "",
    customer_address: item ? item.customer_address : "",
    additionalMobileNumber: item ? item.additionalMobileNumber : "",
    additionalEmailId: item ? item.additionalEmailId : "",
    dateOfBirth: item ? convertToISOFormat(item.dateOfBirth) : "",
    anniversaryDate: item ? convertToISOFormat(item.anniversaryDate) : "",
    occupation: item ? item.occupation : "",
    gender: item ? item.gender : "male",
    occupationBusinessCategory: item ? item.occupationBusinessCategory : "",
    doingBusinessAs: item ? item.doingBusinessAs : "",
    fullNameOfBusiness: item ? item.fullNameOfBusiness : "",
    country: item ? item.country : "IN",
    state: item ? item.state : "BR",
    creditLimit: item ? item.creditLimit : "",
    committedDateToPay: item ? convertToISOFormat(item.committedDateToPay) : "",
    note: item ? item.note : "",
  };
};

export const initialValuesForSuppliers = (item = null) => {
  return {
    gstIn: item ? item.gstIn : "",
    fullName: item ? item.fullName : "",
    email: item ? item.email : "",
    supplierMobile: item ? item.supplierMobile : "",
    buddysinceDate: item
      ? convertToISOFormat(item.buddysinceDate)
      : getCurrentDate(),
    address: item ? item.address : "",
    pan: item ? item.pan : "",
    pincode: item ? item.pincode : "",
    description: item ? item.description : "",
    contactPersonName: item ? item.contactPersonName : "",
    contactPersonPhone: item ? item.contactPersonPhone : "",
    accountNumber:
      item && item.bankDetails ? item.bankDetails.accountNumber : "",
    ifscNumber: item && item.bankDetails ? item.bankDetails.ifscNumber : "",
    accountType:
      item && item.bankDetails ? item.bankDetails.accountType : "savings",
    pendingAmount: item ? item.pendingAmount : "",
    paidAmount: item ? item.paidAmount : "",
    totalPurchase: item ? item.totalPurchase : "",
    advanceamount: item ? item.advanceamount : "",
    country: item ? item.country : "IN",
    state: item ? item.state : "BR",
  };
};

export const intialValuesForEmployee = (item = null) => {
  return {
    employeeName: item ? item.employeeName : "",
    phoneNumber: item ? item.phoneNumber : "",
    position: item ? item.position : "manager",
    otherPosition: item ? item.otherPosition : "",
    employmentStartDate: item
      ? convertToISOFormat(item.employmentStartDate)
      : getCurrentDate(),
    accountNumber: item ? item.accountNumber : "",
    ifscCode: item ? item.ifscCode : "",
    accountType: item ? item.accountType : "savings",
    advanceRequested: item ? item.advanceRequested : "",
    advanceStatus: item ? item.advanceStatus : "",
    employeeSalary: item ? item.employeeSalary : "",
    employeeSalaryPaymentSchedule: item
      ? item.employeeSalaryPaymentSchedule
      : "",
    advanceSalaryPaid: item ? item.advanceSalaryPaid : "",
    address: item ? item.address : "",
    pincode: item ? item.pincode : "",
    storelocation: item ? item.storelocation : "",
    aadharCardNumber: item ? item.aadharCardNumber : "",
    salaryFrequency: item ? item.salaryFrequency : "monthly",
    workingSchedule: item ? item.workingSchedule : "",
    endTime: item ? item.endTime : getCurrentIndianTime(),
    startTime: item ? item.startTime : getCurrentIndianTime(),
    advanceamountPaid: item ? item.advanceamountPaid : "",
    paidDate: item ? convertToISOFormat(item.paidDate) : "",
    employeepaidDate: item
      ? convertToISOFormat(item.employeepaidDate)
      : getCurrentDate(),
    employeeType: item ? item.employeeType : "full_time",
    wageRate: item ? item.wageRate : "daily",
    wageAmount: item ? item.wageAmount : "",
    currency: item ? item.currency : "INR",
    perHour: item ? item.perHour : "",
    password: item ? item.password : "",
    totalHours: item ? item.totalHours : "",
    payFrequency: item ? item.payFrequency : "daily",
    deductions: item ? item.deductions : "",
    paidLeave: item ? item.paidLeave : "",
    seakLeave: item ? item.seakLeave : "",
  };
};

export const initialValuesForSale = (item = null, user) => {
  return {
    saleType: item ? item.saleType : "confirmSale",
    customerName: item ? item.customerName : "",
    mobile: item ? item.mobile : "",
    transactionAmount: item ? item.transactionAmount : "",
    customer_type: item ? item?.customer_type : "consumer",
    sez: item ? item.sez : false,
    export_sale: item ? item.export_sale : false,
    intraState: item ? item?.intraState : false,
    country: item ? item.country : user.country || "IN",
    state: item ? item.state : user.state,
    address: item ? item.address : "",
    saleDate: item ? convertToISOFormat(item.saleDate) : getCurrentDate(),
    items: [],
    transactionStatus: item ? item.transactionStatus : "",

    additionalFee: item?.additionalFee?.map((fee) => ({
      label: fee.label || "Fee",
      amount: fee.amount || 0,
      type: fee.type || "%",
    })) || [{ label: "Fee", amount: 0, type: "%" }],
    additionalDiscount: item?.additionalDiscount?.map((discount) => ({
      label: discount.label || "Discount",
      amount: discount.amount || 0,
      type: discount.type || "%",
    })) || [{ label: "Discount", amount: 0, type: "%" }],

    committedDateToPay: item ? item.committedDateToPay : "",
    roundOff: "",
    paymentMode: item ? item.paymentMode : "",
    deliveryDate: item
      ? convertToISOFormat(item?.deliveryPreference?.deliveryDate)
      : "",
    deliveryTime: item
      ? item?.deliveryPreference?.deliveryTime
      : getCurrentIndianTime(),
    assignedEmployee: item ? item?.deliveryPreference?.assignedEmployee : "",
    deliveryAddress: item ? item.deliveryAddress : "",
    deliveryFee: item ? item.deliveryFee : "",
    pickupDate: item ? item.pickupDate : "",
    pickupTime: item ? item.pickupTime : getCurrentIndianTime(),
    gstNo: item ? item.gstNo : "",
    showGST: item ? item.showGST : true,
    ubscriptionDisc: item ? item.subscriptionDisc : 0,
    deliveryType: item ? item.deliveryType : "takeout",
    notes: item ? item.notes : "",
  };
};

export const initialValuesForPurchase = (item = null, user) => {
  // console.log("line no 238", user);
  return {
    gstNumber: item ? item.gstNumber : "",
    fullName: item ? item.fullName : "",
    address: item ? item.address : "",
    supplierMobile: item ? item.supplierMobile : "",
    intimationDate: item
      ? convertToISOFormat(item.intimationDate)
      : getCurrentDate(),
    intimationTime: item ? item.intimationTime : getCurrentIndianTime(),
    expectedDate: item
      ? convertToISOFormat(item.expectedDate)
      : getCurrentDate(),
    expectedTime: item ? item.expectedTime : getCurrentIndianTime(),
    transactionAmount: item ? item.transactionAmount : "",
    items: [],
    transactionStatus: item ? item.transactionStatus : "not_paid",
    orderStatus: item ? item.orderStatus : "ordered",
    buyNote: item ? item.buyNote : "",
    refInvoiceNo:item ? item.refInvoiceNo : "",
    assignedAgent : item ? item.assignedAgent : "",
    totalPaid: item ? item.totalPaid : "",
    remainingTransactionAmount: item ? item.remainingTransactionAmount : "",
    committedDateToPay: item ? item.committedDateToPay : "",
    country: item ? item.country : "IN",
    state: item ? item.state : user.state,
    supplierType: item ? item.supplierType : "registered",
    advanceAmount: item ? item.advanceAmount : "",

    additionalFee: item?.additionalFee?.map((fee) => ({
      label: fee.label || "Fee",
      amount: fee.amount || 0,
      type: fee.type || "%",
    })) || [{ label: "Fee", amount: 0, type: "%" }],
    additionalDiscount: item?.additionalDiscount?.map((discount) => ({
      label: discount.label || "Discount",
      amount: discount.amount || 0,
      type: discount.type === "%" || discount.type === "₹" ? discount.type : "%",
    })) || [{ label: "Discount", amount: 0, type: "%" }],
  };
};

export const initialValuesForCashBook = (item = null) => {
  return {
    transactionType: item ? item.category : "",
    paymentMode: item ? item?.paymentMode : "cash",
    description: item ? item.description : "",
    amount: item ? item.amount : "",
    document: item ? item.document : "",
    transactionDate: item
      ? convertToISOFormat(item.transactionDate)
      : getCurrentDate(),
    transactionName: item ? item.transactionName : "",
  };
};

export const initialValuesForIncome = (item = null) => {
  return {
    incomeName: item ? item.incomeName : "",
    incomeType: item ? item.incomeType : "Direct",
    description: item ? item.description : "",
    reference: item ? item.reference : "",
    incomeCategory: item ? item.incomeCategory : "sales",
    amount: item ? item.amount : "",
    date: item ? convertToISOFormat(item.date) : getCurrentDate(),
    incomeTime: item ? item.incomeTime : getCurrentIndianTime(),
    incomeOtherCategory: item ? item.incomeOtherCategory : "",
    taxableIncome: item ? item.taxableIncome : "no_tax",
    igst: item ? item?.igst : "",
    cgst: item ? item?.cgst : "",
    sgst_utgst: item ? item?.sgst_utgst : "",
    cess: item ? item?.cess : "",
    totalAmount: item ? item.totalAmount : "",
  };
};

export const initialValuesForDebitCredit = (item = null, credit = false) => {
  return {
    noteType: item ? item.noteType : credit === true ? "credit" : "debit",
    issueOrReceipt: item ? item.issueOrReceipt : "issue",
    referenceInvoice: item ? item.referenceInvoice : "",
    amount: item ? item.amount : "",
    items: item ? item.items : [],
    noteNumber: item ? item.noteNumber : "",
    issueDate: item ? convertToISOFormat(item.issueDate) : getCurrentDate(),
    reason: item ? item.reason : "",
    customerOrSupplier: item ? item.customerOrSupplier : "customer",
    customerName: item ? item?.customerName : "",
    customerMobile: item ? item?.customerMobile : "",
    gstIn: item ? item?.gstIn : "",
    issueOrrecive: item ? item?.issueOrrecive : "issue",
    document: item ? item?.document : "",
    noteRefrenceNumber: item ? item.noteRefrenceNumber : "",
  };
};
export const initialValuesForManufacturing = (item = null) => {
  const currentDate = new Date().toISOString().split("T")[0];
  const expectedDate = new Date();
  expectedDate.setDate(expectedDate.getDate() + 7);
  const expectedDateStr = expectedDate.toISOString().split("T")[0];

  if (item) {
    return {
      manufacturingName: item.manufacturingName || "",
      manufacturingDate: item.manufacturingDate || currentDate,
      expectedCompletionDate: item.expectedCompletionDate || expectedDateStr,
      manufacturingProcess: item.manufacturingProcess || "assembly",
      description: item.description || "",
      laborCost: item.laborCost || 0, // Changed from "0" to 0
      utilityCost: item.utilityCost || 0, // Changed from "0" to 0
      otherCost: item.otherCost || 0, // Changed from "0" to 0
      notes: item.notes || "",
    };
  }

  return {
    manufacturingName: "",
    manufacturingDate: currentDate,
    expectedCompletionDate: expectedDateStr,
    manufacturingProcess: "assembly",
    description: "",
    laborCost: 0, // Changed from "0" to 0
    utilityCost: 0, // Changed from "0" to 0
    otherCost: 0, // Changed from "0" to 0
    notes: "",
  };
};
